import {useLayoutEffect, useState} from 'react';

/**
 * Hook to return the scroll position of the window
 */
const useScroll = () => {
    const [scroll, setScroll] = useState({x: 0, y: 0});
    useLayoutEffect(() => {
        const updateScroll = () => {
            setScroll({x: window.scrollX, y: window.scrollY});
        };
        window.addEventListener('scroll', updateScroll);
        updateScroll();

        return () => window.removeEventListener('scroll', updateScroll);
    }, []);

    return scroll;
};

export default useScroll;
